import { React, models, kea, history, resources, selectores, componentToRx, fa } from "app/main/std";
interface Props {
    usuario: models.Session | null;
}
class UsuarioPermisos extends React.PureComponent<Props> {
    render() {
        const props = this.props;
        return (
            <span>
                <i className={fa("user")} />
                {(props.usuario && props.usuario.Turno.EnTurno) &&
                    <span>
                        <label className="label label-default">
                            {props.usuario.Turno.Cajas.Documentacion && "D"}
                            {props.usuario.Turno.Cajas.EntregaDomicilio && "E"}
                            {props.usuario.Turno.Cajas.EntregaOcurre && "O"}
                            {props.usuario.Turno.Cajas.Cobranza && "C"}
                            {props.usuario.Turno.Cajas.Facturacion && "F"}
                            {props.usuario.Turno.Cajas.PaquetePP && "P"}
                        </label>
                    </span>
                }

                {(props.usuario && !props.usuario.Turno.EnTurno) &&
                    <span title="Usuario sin turno">
                        <i className={fa("clock-o")} />
                    </span>}
                {props.usuario ? props.usuario.Nombre : ""}
            </span>
        )
    }
}
const UsuarioRx = componentToRx(UsuarioPermisos);
export const Usuario = () => <UsuarioRx usuario={resources.User.SessionRx} />


// WEBPACK FOOTER //
// ./app/features/inicio/usuarioButton.tsx